/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `DATA_VECTOR` - vektorová data
 *   * `DATA_RASTER` - rastrová data
 *   * `SERVICES` - služby
 *   * `PRINT` - tisk
 * ```
 */
export const PriceListItemTypesEnum = {
  DATA_VECTOR: 'DATA_VECTOR',
  DATA_RASTER: 'DATA_RASTER',
  SERVICES: 'SERVICES',
  PRINT: 'PRINT',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PriceListItemTypesEnum = ValuesOf<typeof PriceListItemTypesEnum>;

export type PriceListItemTypesEnumRequest = PriceListItemTypesEnum;
export type PriceListItemTypesEnumResponse = PriceListItemTypesEnum;
